import { render, staticRenderFns } from "./LichSuTourDuLichList.vue?vue&type=template&id=2278e40e"
import script from "./LichSuTourDuLichList.vue?vue&type=script&lang=js"
export * from "./LichSuTourDuLichList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports